import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import IntegrationModel from "./models/IntegrationModel";
import SearchAnagCqCrmModel from "./models/SearchAnagCqCrmModel";
import ResultModel from "./models/ResultModel";

export interface ISearchAnagCqCrmRequest {
    email: string;
    phoneNumber: string;
    taxCode: string;
    idAgent: number;
}

export default class IntegrationEffect {
    public static async integration(totp: string): Promise<IntegrationModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.integration + `?totp=${totp}`;
        return EffectUtility.getToModel<IntegrationModel>(IntegrationModel, endpoint);
    }

    public static async searchAnagCqCrm(
        request: ISearchAnagCqCrmRequest
    ): Promise<SearchAnagCqCrmModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.searchAnagCqCrm;
        return EffectUtility.postToModel<SearchAnagCqCrmModel>(SearchAnagCqCrmModel, endpoint, request);
    }

    public static async existsAnagCqCrmOutVisibility(
        request: ISearchAnagCqCrmRequest
    ): Promise<ResultModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.existsAnagCqCrmOutVisibility;
        return EffectUtility.postToModel<ResultModel>(ResultModel, endpoint, request);
    }
}
